import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { NAVER_ACCOUNT_ID } from "@/services/analyticsEvents/naverAdsEvent";

const INFLOW_DOMAIN = "me-qr.com";

function trackPageView() {
  if (!window.wcs || !window.wcs_do) return;

  window.wcs_add = window.wcs_add || {};
  window.wcs_add.wa = NAVER_ACCOUNT_ID;
  window.wcs_do();
}

function loadScript() {
  if (window.wcs) return;

  const s = document.createElement("script");
  s.type = "text/javascript";
  s.async = true;
  s.src = "https://wcs.naver.net/wcslog.js";
  s.onload = () => {
    window.wcs_add = window.wcs_add || {};
    window.wcs_add.wa = NAVER_ACCOUNT_ID;
    window.wcs?.inflow(INFLOW_DOMAIN);
    trackPageView();
  };

  document.head.appendChild(s);
}

function useNaverAdsPixel(enabled = false, timeout = 0) {
  const { pathname } = useLocation();
  const isEnabled = enabled && !!NAVER_ACCOUNT_ID;

  useEffect(() => {
    if (!isEnabled) return;

    const timeoutId = window.setTimeout(loadScript, timeout);

    return () => window.clearTimeout(timeoutId);
  }, [isEnabled, timeout]);

  useEffect(() => {
    if (!isEnabled) return;

    trackPageView();
  }, [isEnabled, pathname]);
}

export default useNaverAdsPixel;
